import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "button-div-poi" }
const _hoisted_2 = { class: "div-chexbox-button-poi" }

import ButtonSquareHoverChecklist from '@/components/general/buttons/ButtonSquareHoverChecklist.vue'
import ListMenuWithCheckbox from '@/components/general/lists/ListMenuWithCheckbox/ListMenuWithCheckbox.vue'
import { useStore } from 'vuex'
import { computed, toRefs, watch } from 'vue'
import { SET_POI_MENU } from '@/store/mutation-types'
import { CategoryItem } from '@/components/general/lists/ListMenuWithCheckbox/ListMenuWithCheckbox.vue'

interface Props {
  title: string
  showPoiMenu?: boolean
  categories: CategoryItem[]
  showPoiMenuHover: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'PlanviewPoiButton',
  props: {
    title: {},
    showPoiMenu: { type: Boolean },
    categories: {},
    showPoiMenuHover: { type: Boolean }
  },
  emits: [
  'PlanviewPoiButtonHovered',
  'onChecklistToggle',
  'onHoverListMenu',
  'closeHoverListMenu'
],
  setup(__props: any, { emit: __emit }) {

const props = __props
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { showPoiMenu, categories, showPoiMenuHover } = toRefs(props)

const emits = __emit
const store = useStore()

const poisForSelectedLevel = computed(() => store.state.planview.poisForSelectedLevel)
function poiButtonActiveState() {
  if (!categories.value.length) return 'deactivated'
  return showPoiMenu?.value ? 'active' : 'inactive'
}

function onChecklistToggle(typeId, categoryId, checked) {
  emits('onChecklistToggle', typeId, categoryId, checked)
}
function toggleVisible() {
  if (!categories.value.length) return
  store.commit(SET_POI_MENU, !store.state.showPoiMenu)
}

const poiCategoriesForSelectedLevel = computed(
  () => store.state.planview.poiCategoriesForSelectedLevel
)
watch(poisForSelectedLevel, (newPoisArray) => {
  if (newPoisArray) {
    const updatedCategories = [...poiCategoriesForSelectedLevel.value]
    poiCategoriesForSelectedLevel.value.forEach((poiCategory, categoryIndex) => {
      poiCategory?.types.forEach((poiType, typeIndex) => {
        const poiExistsInType = newPoisArray.find((poi) => poi.properties.typeId === poiType.id)
        // Removing empty type and/or category after poi category is edited
        if (!poiExistsInType && poiType.visible) {
          if (poiCategory.types.length > 1) {
            // Remove the type only from store
            updatedCategories[categoryIndex].types.splice(typeIndex, 1)
          } else if (poiCategory.types.length === 1) {
            // Remove the full category from store
            updatedCategories.splice(categoryIndex, 1)
          }
          store.commit('planview/SET_POI_CATEGORIES_FOR_SELECTED_LEVEL', updatedCategories)
        }
      })
    })
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(showPoiMenu) || _unref(showPoiMenuHover))
        ? (_openBlock(), _createBlock(ListMenuWithCheckbox, {
            key: 0,
            categories: _unref(categories),
            title: _ctx.$t('general__view__pois'),
            onOnChecklistToggle: onChecklistToggle,
            onOnHoverListMenu: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onHoverListMenu'))),
            onCloseHoverListMenu: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closeHoverListMenu')))
          }, null, 8, ["categories", "title"]))
        : _createCommentVNode("", true),
      _createVNode(ButtonSquareHoverChecklist, {
        title: _ctx.$t('general__view__pois'),
        imgSource: require('@/assets/icons-general/icon-poi.svg'),
        size: "large",
        activeState: poiButtonActiveState(),
        style: {"padding-top":"24px"},
        onClicked: _cache[2] || (_cache[2] = ($event: any) => (toggleVisible())),
        onHovered: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('PlanviewPoiButtonHovered')))
      }, null, 8, ["title", "imgSource", "activeState"])
    ])
  ]))
}
}

})